import { HomeIcon, TagIcon, MoneyIcon, MenuIcon } from '@nimbus-ds/icons';
import { NavTabs } from '@nimbus-ds/patterns';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router';
import { useNavegate } from 'App/hooks';
import { useGetNewOrdersCount } from 'domains/Orders/Orders/hooks';
import useNavTabs from './useNavTabs';
import NavTabsContainer from '../NavTabsContainer';
import ShowByRole from '../ShowByRole';
import './Navtabs.scss';

function NavTabsWeb() {
  const count = useGetNewOrdersCount();
  const { pathname } = useLocation();
  const { toggleSideBar } = useNavTabs();
  const { t } = useTranslation(['common']);
  const { goTo } = useNavegate();
  const openMenu = () => toggleSideBar();

  return (
    <NavTabsContainer>
      <div className="stratus--nav-tabs-container">
        <NavTabs>
          <NavTabs.Item
            ariaLabel={t('menu.dashboard')}
            icon={<HomeIcon size="medium" />}
            onClick={() => goTo('/')}
            active={pathname === '/'}
          />
          <ShowByRole includeRoles="orders">
            <NavTabs.Item
              ariaLabel={t('menu.orders')}
              badge={count > 0}
              icon={<MoneyIcon size="medium" />}
              onClick={() => goTo('/orders')}
              active={pathname.startsWith('/orders')}
            />
          </ShowByRole>
          <ShowByRole includeRoles="products">
            <NavTabs.Item
              ariaLabel={t('menu.products')}
              icon={<TagIcon size="medium" />}
              onClick={() => goTo('/products')}
              active={pathname.startsWith('/products')}
            />
          </ShowByRole>
          <NavTabs.Item
            ariaLabel={t('menu.hamburger')}
            icon={<MenuIcon size="medium" />}
            onClick={openMenu}
          />
        </NavTabs>
      </div>
    </NavTabsContainer>
  );
}

export default NavTabsWeb;
